import React from "react";
import { useTranslation } from "react-i18next";

import { getFullAddress } from "fe-shared-transactions/src/helpers/address";
import { Address } from "fe-shared-transactions/src/types";

import styles from "../InventoryAdjustmentsDetails.module.scss";

interface Props {
  address: Address;
}

const InventoryAdjustmentDetailsStorageInfoSection = ({ address }: Props) => {
  const { t } = useTranslation();

  return (
    <section>
      <h2 className={styles.sectionTitle}>
        {t("inventoryAdjustment.details.storageYard")}
      </h2>
      <p className={styles.sectionSubtitle}>{getFullAddress(address)}</p>
    </section>
  );
};

export default InventoryAdjustmentDetailsStorageInfoSection;
